const provinces = ['北京', '天津', '上海', '重庆', '河北', '山西', '辽宁', '吉林', '黑龙江', '江苏', '浙江', '安徽', '福建', '江西', '山东', '河南', '湖北', '湖南', '广东', '海南', '四川', '贵州', '云南', '陕西', '甘肃', '青海', '内蒙古', '广西', '西藏', '宁夏', '新疆']

const years = []

for (var i = 2020; i >= 1977; i--) {
  years.push(i)
}

const articles = [
  "<div>备考时妈妈送到房间的苹果</div><div>现在想起还是觉得香甜</div>",
  "<div>父母送我到考场的谆谆祝福</div><div>现在想起来还是觉得幸福</div>",
  "<div>好想重新吃一次</div><div><div</div>高考时</div><div>爸妈每天为我准备的营养餐</div>",
  "<div>一起在快餐店</div><div><div</div>学习到深夜的日子</div><div>是青春的独家记忆</div>",
  "<div>考同一个学校的雄心壮志</div><div>是不是都有实现？</div>",
  "<div>考试结束就可以牵你的手</div><div>酸甜苦辣都与你一起品尝</div>",
  "<div>高考结束后的那顿散伙饭</div><div>笑中带泪的永恒记忆</div>",
  "<div>高考了才知道</div><div><div</div>三短一长选最长</div><div>原来一直都是个谬论</div>",
  "<div>高考之前</div><div><div</div>一直在想是去清华还是北大</div><div>后来才发现是想多了</div>",
  "<div>高考前总想着考完之后</div><div><div</div>要放纵一下尝尝啤酒的滋味</div><div><div</div>现在低头看看自己的啤酒肚</div><div>当年还是太年轻了！</div>",
  "<div>无论遇见什么难题</div><div>都要答好每一张人生考卷</div>",
  "<div>你只管努力</div><div>其它的交给天意</div>",
  "<div>每一天的努力</div><div>都在为人生不断蓄力</div>",
  "愿自己归来仍是少年",
  "<div>高考不是终点</div><div>更是下一段精彩的起点</div>",
  "<div>每一个片段</div><div>都是一段独家记忆</div>",
  "<div>墨迹虽已褪色</div><div>初心始终不变</div>",
  "风雨过后，总会有彩虹",
  "<div>为什么依旧怀念那个夏天</div><div>因为那是青春的印记</div>",
  "<div>经历过高考</div><div>人生的难题都不在话下</div>",
  "<div>和最美好的你</div><div>分享最美好的回忆</div>",
  "想回到过去,再经历一次",
  "<div>总有些时候</div><div><div</div>你会遇见更好的自己</div><div>比如：高考</div>",
  "<div>享受过程，拥抱结果</div><div>不期而遇的惊喜更让人着迷</div>",
  "<div>点燃内心那盏灯</div><div>它会指引你走向正确的方向</div>",
  "<div>如果有机会</div><div><div</div>我也想亲身经历一次</div><div>不曾有过的高考年华</div>",
  "<div>我想重回青春考场</div><div>不给自己留下遗憾</div>",
  "<div>想回到过去</div><div><div</div>给朋友们大大的拥抱</div><div>重燃我的青春</div>",
  "<div>生活是一场去除浮躁的试炼</div><div>关掉噪音，重回那个盛夏</div>",
  "<div>当初最想逃离的家乡</div><div>是现在最想回去的地方</div>",

]

const articlesUniq = {
  "1977": "<div>高考于我</div><div>是打开一片全新的天地</div>",
  "1997": "<div>回归祖国母亲的怀抱</div><div>让我更期待梦想的远方</div>",
  "2000": "<div>千禧年迈进考场的我</div><div>对世界充满好奇与向往</div>",
  "2003": "<div>那一年</div><div>我的心中只有这支笔</div><div>和对未来的无限期待</div>",
  "2008": "<div>为中华崛起而读书</div><div>奥运年的我意气风发</div>",
  "2018": "<div>第一批00后高考</div><div>是我铭记一生的时刻</div>",
  "2020": "<div>环境再难依然信心百倍</div><div>砥砺前行！</div>",
}

export {
  years,
  provinces,
  articles,
  articlesUniq
}